import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Link,
  Dialog,
  DialogTitle,
  DialogContentText,
} from "@mui/material";
import Logo from "../../imagens/logo-azul";
import AuthService from "../../AuthService";
import { useSnackbar } from "notistack";
import Fundo from "../../imagens/fundo-qrpedir-min.png";

const RecuperarSenha = () => {
  const [email, setEmail] = useState("");
  const [confirmado, setConfirmado] = useState(false);
  const [token, setToken] = useState("");
  const [nome, setNome] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    setConfirmado(false);
  };

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const verificarEmail = () => {
    const service = new AuthService();

    service
      .get(`/usuario/getByEmail?email=${email}`)
      .then((retorno) => {
        setToken(retorno.token);
        setNome(retorno.nome);
        setConfirmado(true);
        sendEmail();
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Seu e-mail está incorreto", { variant: "error" });
      });
  };

  const sendEmail = () => {
    const service = new AuthService();

    service
      .put(
        `/usuario/sendEmail?email=${email}&subject=${"Recuperação de senha"}&templateHtmlName=${"template-email-recuperar-senha"}&token=${token}&nome=${nome}`
      )
      .catch((err) => {
        console.error(err);
      });
  };

  document.title = "QR Pedir - Recuperar senha";

  return (
    <Box
      sx={{ height: "100vh", background: `url(${Fundo}) repeat` }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box display="flex" justifyContent="center" p={4} mt={6}>
        <Logo
          style={{ width: "15vw", minWidth: "200px", height: "auto" }}
          alt="logo"
        />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        style={{ height: "800px" }}
      >
        <Card
          sx={{
            padding: "2vw",
            paddingBottom: "20px",
            width: "30vw",
            minWidth: "300px",
            maxWidth: "450px",
            maxHeight: "500px",
          }}
        >
          <Typography variant="h5" align="center">
            Recuperação de senha
          </Typography>
          <Box display="flex" flexDirection="column" alignItems="center" mt={3}>
            <TextField
              variant="outlined"
              label="E-mail"
              id="email"
              name="email"
              placeholder="meu_email@exemplo.com"
              sx={{ width: "100%", marginBottom: "20px" }}
              onChange={handleChange}
            />
            <Button
              color="primary"
              variant="contained"
              sx={{ width: "100px", margin: "25px 0px 30px 0px" }}
              onClick={verificarEmail}
            >
              Enviar
            </Button>
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                window.open("/login", "_parent");
              }}
            >
              Voltar a Página Inicial
            </Link>
            <Box style={{ margin: "10px 0px 0px 0px" }}>
              <Link
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  window.open("https://qrpedir.com/suporte", "_blank");
                }}
              >
                Entre em contato
              </Link>
            </Box>
          </Box>
        </Card>

        <Dialog
          open={confirmado}
          onClose={handleClose}
          maxWidth="xs"
          fullWidth
          align="center"
        >
          <DialogTitle>Confirmação</DialogTitle>
          <DialogContentText>
            Uma mensagem de confirmação foi enviada para {email}, confira seu
            e-mail para continuar.
          </DialogContentText>
          <Box display="flex" flexDirection="row" justifyContent="center">
            <Button
              color="primary"
              variant="contained"
              style={{ margin: "10px 0px 20px 10px" }}
              onClick={handleClose}
            >
              Confirmar
            </Button>
          </Box>
        </Dialog>
      </Box>
    </Box>
  );
};

export default RecuperarSenha;
